import * as React from 'react';
import FilterBar from 'components/Forms/DataGrid/FilterBar';
import { Row, Col, Form } from 'antd';
import FilterTextbox from 'components/Forms/DataGrid/FilterTextbox';
import InfoIcon from 'components/Forms/InfoIcon';
import FilterDatePicker from 'components/Forms/DataGrid/FilterDatePicker';
import { FilterType, JoinType } from 'Core/Api/Api';
import FilterDateRangePicker from 'components/Forms/DataGrid/FilterDateRangePicker';
import FilterSelectbox from 'components/Forms/DataGrid/FilterSelectbox';
import UserHandler from '../../JcsdAccountHandler';
import IFilterSelectOption from 'components/Forms/DataGrid/FilterSelectbox/IFilterSelectOption';

export interface Props {
    children?: React.ReactNode;
}

export interface State {

}
export default class JcsdAccountListFilterBar extends React.Component<Props, State> {
    handler: UserHandler;

    constructor(props: Props) {
        super(props);

        this.state = {

        };
        this.handler = new UserHandler(props);
    }

    componentDidMount() {

    }



    render() {
        return (
            <FilterBar>
                <Row>
                    <Col xs={24} sm={15}>
                        <Form.Item label="Search" labelAlign="left" labelCol={{ xs: { span: 14 }, sm: { span: 10 }, lg: { span: 9 } }} wrapperCol={{ xs: { span: 14 }, sm: { span: 14 }, lg: { span: 15 } }}>
                            <FilterTextbox
                                filterFields="name,jcsdnumber"
                                filterJoin={JoinType.And}
                                suffix={<InfoIcon text="Search name" />}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </FilterBar>
        );
    }
}



